import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class CategoryfoodService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('categoryfood/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('categoryfood/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('categoryfood/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('categoryfood/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('categoryfood/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('categoryfood/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('categoryfood/delete', val_id);
  }
}
